/* eslint-disable import/prefer-default-export */

export const validateFieldsAtSubmit = async (
  values,
  columnMappings,
  fillingStatus,
  containerType,
  globalActions,
  t,
  displayStyles = {},
) => {
  const errors = [];

  if (fillingStatus === 'empty') {
    return true;
  }

  // Helper function to check if field is hidden
  const isFieldHidden = (fieldName) => displayStyles[fieldName] === 'hidden';

  // Check if any volume fields are provided (only if not hidden)
  const volumeFieldsSubmit = (!isFieldHidden('liquidVolume') && !!values.liquidVolume.value)
    || (!isFieldHidden('volumeTemperature') && !!values.volumeTemp.value);

  // Check if any TAV fields are provided (only if not hidden)
  const tavFieldsSubmit = (!isFieldHidden('tav') && !!values.tav.value)
    || (!isFieldHidden('tavTemperature') && !!values.tavTemp.value);

  // Check if any custom fields are provided
  const hasCustomFields = Object.keys(values).some((key) => {
    // Check if this is a custom field (not a standard field)
    const standardFields = ['liquidVolume', 'volumeTemp', 'tav', 'tavTemp', 'totalCapacity', 'usableCapacity'];
    if (standardFields.includes(key)) return false;

    // Check if the field has a value
    return Boolean(values[key]?.value);
  });

  // Allow submission if any fields are provided (volume, TAV, or custom fields)
  if (!volumeFieldsSubmit && !tavFieldsSubmit && !hasCustomFields) {
    errors.push(t('operation.barrel.errors.noFieldsProvided'));
    globalActions.setSnackbarMessage({ message: t('volume_or_tav_fields'), severity: 'warning' });
    return false;
  }

  // Simplified validation logic based on new requirements:
  // volumeStatus: volumeTemperature AND liquidVolume
  // tavStatus: tavTemperature AND tav

  if (volumeFieldsSubmit) {
    // For volume fields, we allow partial data entry
    // The volume status completion logic is handled in Operation.js
    // Here we just ensure that if fields are provided, they are valid
    // No additional validation needed for volume fields
  }

  if (tavFieldsSubmit) {
    // For TAV fields, we allow partial data entry
    // The TAV status completion logic is handled in Operation.js
    // Here we just ensure that if fields are provided, they are valid
    // No additional validation needed for TAV fields
  }

  if (errors.length > 0) {
    const combinedErrorMessage = errors.join(', ');
    globalActions.setSnackbarMessage({ message: combinedErrorMessage, severity: 'warning' });

    return false;
  }

  return true;
};
